import {startOfDay, startOfMonth, startOfQuarter, startOfWeek, startOfYear} from 'date-fns';

import {DashboardDateType, DateRange} from 'types/dashboard';

export function dashboardPeriod(type: DashboardDateType, now = new Date()): DateRange {
    const starts = {
        [DashboardDateType.Day]: startOfDay,
        [DashboardDateType.Week]: (date: Date) => startOfWeek(date, {weekStartsOn: 1}),
        [DashboardDateType.Month]: startOfMonth,
        [DashboardDateType.Quarter]: startOfQuarter,
        [DashboardDateType.Year]: startOfYear,
        [DashboardDateType.Period]: startOfMonth,
    };
    return {start: starts[type](now), end: new Date(now)};
}
